export const DASHBOARD_HEADER_SAVI_ENGAGEICON =
  'ispm-dashboard-header-saviEngageIcon';
export const DASHBOARD_HEADER_SAVI_RESUMEICON =
  'ispm-dashboard-header-saviResumeIcon';
export const DASHBOARD_HEADER_SAVI_INPUTBOX =
  'ispm-dashboard-header-saviInputBox';
export const CHATOVERLAY_HEADER_CLOSEICON = 'ispm-chatOverlay-header-closeIcon';
export const CHATOVERLAY_HEADER_RESETICON = 'ispm-chatOverlay-header-resetIcon';
export const DASHBOARD_BODY = 'ispm-dashboard-body';
export const CHATOVERLAY_DATAPANEL = 'ispm-chatOverlay-dataPanel';
export const TABLE_HEADER_TOOLTIP = 'ispm-tableHeader-detailedStepsTooltip';
